import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'src/components/Elements/Badge';
import { isMobileV2 } from 'src/utils/ui';
import { getBadgeStatusConfig } from 'src/containers/Account/OrdersPage/utils';
import { ServiceHeading } from './OrderStatusHeader.ServiceHeading';

/**
 * @param {object} props
 * @param {Order} props.order
 * @param {{type: string, variant?: string}} props.badgeType
 * @param {string} props.label
 */
const OrderStatusHeader = ({ order, badgeType, label }) => {
  if (!order) return null;

  const { statusBadgeType, statusLabel } = getBadgeStatusConfig(order, badgeType, label);
  const isMobile = isMobileV2();

  return (
    <div className="flex justifyContentSpaceBetween">
      <div>
        <p className="overline-small n700 marginBottom-tiny">{`#${order.id}`}</p>
        <ServiceHeading order={order} />
      </div>
      <Badge
        size={isMobile ? 'small' : 'large'}
        type={statusBadgeType.type}
        variant={statusBadgeType.variant}
      >
        {statusLabel}
      </Badge>
    </div>
  );
};

// ###########
// PROP TYPES
// ###########

OrderStatusHeader.propTypes = {
  order: PropTypes.any,
  badgeType: PropTypes.shape({
    type: PropTypes.string,
    variant: PropTypes.string,
  }),
  label: PropTypes.string,
};

export default React.memo(OrderStatusHeader);
